(function () {
  var root = document.getElementById('m1dz');
  if (!root) return;
  root.innerHTML = "<div class=\"m1dz-lang\" role=\"group\" aria-label=\"Language\">\n    <button type=\"button\" data-lang=\"zh\">中文</button>\n    <button type=\"button\" data-lang=\"en\">English</button>\n    <button type=\"button\" data-lang=\"vi\">Tiếng Việt</button>\n  </div>\n  <h2 data-t=\"title\"></h2>\n  <p class=\"m1dz-sub\" data-t=\"sub\"></p>\n  <div class=\"m1dz-form\">\n    <label><span data-t=\"postal\"></span>\n      <input id=\"m1dz-code\" type=\"text\" inputmode=\"text\" autocomplete=\"off\" autocapitalize=\"characters\"\n             spellcheck=\"false\" maxlength=\"7\" placeholder=\"L3P\"></label>\n    <label><span data-t=\"subtotal\"></span>\n      <input id=\"m1dz-amt\" type=\"text\" inputmode=\"decimal\" autocomplete=\"off\" placeholder=\"$\"></label>\n  </div>\n  <div id=\"m1dz-out\" aria-live=\"polite\"></div>\n  <p class=\"m1dz-foot\"><span data-t=\"basis\"></span><br><span data-t=\"bulky\"></span></p>\n  <a id=\"m1dz-pending\" class=\"m1dz-btn\" target=\"_blank\" rel=\"noopener\" data-t=\"staff\"></a>\n  <p class=\"m1dz-foot\" id=\"m1dz-stamp\"></p>";
  var css = document.createElement('style');
  css.textContent = "#m1dz{max-width:560px;margin:0 auto;padding:8px 0 32px;font-size:17px;line-height:1.5;color:#1c1c1c}\n#m1dz *{box-sizing:border-box}\n#m1dz h2{margin:12px 0 4px;font-size:26px;line-height:1.25}\n#m1dz .m1dz-sub{margin:0 0 18px;color:#5c5c5c;font-size:15px}\n#m1dz .m1dz-lang{display:flex;gap:6px;justify-content:flex-end}\n#m1dz .m1dz-lang button{border:1px solid #c9c9c9;background:#fff;color:#1c1c1c;border-radius:999px;padding:5px 12px;font:inherit;font-size:14px;cursor:pointer}\n#m1dz .m1dz-lang button[aria-pressed=\"true\"]{background:#1c1c1c;border-color:#1c1c1c;color:#fff}\n#m1dz .m1dz-form{display:grid;grid-template-columns:1fr 1fr;gap:12px}\n#m1dz label{display:block;font-size:14px;color:#5c5c5c}\n#m1dz input{display:block;width:100%;margin-top:4px;padding:12px 14px;border:2px solid #c9c9c9;border-radius:10px;background:#fff;color:#1c1c1c;font:inherit;font-size:24px;font-weight:600;letter-spacing:.04em;text-transform:uppercase}\n#m1dz input:focus{outline:none;border-color:#1c1c1c}\n#m1dz #m1dz-out{margin-top:18px;min-height:40px}\n#m1dz .m1dz-card{border:1px solid #dedede;border-radius:14px;padding:18px;background:#fafafa}\n#m1dz .m1dz-area{font-size:15px;color:#5c5c5c;overflow-wrap:anywhere}\n#m1dz .m1dz-zone{display:inline-block;margin-left:6px;padding:1px 9px;border-radius:999px;background:#1c1c1c;color:#fff;font-size:13px;font-weight:600;white-space:nowrap}\n#m1dz .m1dz-big{margin:8px 0 2px;font-size:28px;font-weight:700;line-height:1.2}\n#m1dz .m1dz-ok{color:#11703a}\n#m1dz .m1dz-need{color:#a35200}\n#m1dz .m1dz-no{color:#a3231c}\n#m1dz .m1dz-row{margin-top:10px}\n#m1dz .m1dz-opts{margin:6px 0 0;padding-left:22px}\n#m1dz .m1dz-opts li{margin:4px 0}\n#m1dz .m1dz-muted{color:#5c5c5c;font-size:15px}\n#m1dz .m1dz-foot{margin:16px 0 0;color:#6e6e6e;font-size:13px}\n#m1dz a.m1dz-btn{display:block;margin:20px 0 0;padding:14px 18px;border:2px solid #1c1c1c;border-radius:10px;background:#fff;color:#1c1c1c;font-size:18px;font-weight:600;line-height:1.3;text-align:center;text-decoration:none}\n#m1dz a.m1dz-btn:hover,#m1dz a.m1dz-btn:focus-visible{background:#1c1c1c;color:#fff}\n#m1dz a.m1dz-btn[hidden]{display:none}\n@media (max-width:420px){#m1dz .m1dz-form{grid-template-columns:1fr}#m1dz .m1dz-big{font-size:24px}}";
  document.head.appendChild(css);
  var WEB = { on: [99.95, 13.95], other: [149.95, 18.95] };  // monesupply.ca shipping rules
  var CACHE_KEY = 'm1dz-data-v1';
  var T = {
    zh: {
      title: '司机送货查询', sub: '适用于店里、电话、微信下单，由本店司机送货的订单',
      postal: '邮编前三位', subtotal: '税前小计 Subtotal（可不填）',
      zone: '{z} 档', freeOver: '满 {x} 免费送货', ok: '已达门槛，免费送货',
      need: '再加 {x} 即可免费送货', choose: '未满 {x} 可以选择：',
      optFee: '付送货费 {x}', optWait: '免费等顺路送（不保证送达时间）',
      eta: '送达时间：', noDrv: '这个地区司机不送',
      webOn: '请在 monesupply.ca 下单：安省满 ${a} 包邮，未满运费 ${b}',
      webOther: '请在 monesupply.ca 下单：满 ${a} 包邮，未满运费 ${b}',
      unknown: '这个邮编未收录，请问经理', invalid: '请输入邮编前三位，例如 L3P',
      basis: '金额按税前、折扣后的小计计算。', bulky: '大件家具、设备请先确认车辆能否装载。',
      staff: '员工：登记等顺路订单', loading: '正在读取数据…', failed: '数据读取失败，请检查网络后刷新。',
      stamp: '数据更新于 {x}'
    },
    en: {
      title: 'Local Delivery Check', sub: 'For in-store, phone and WeChat orders delivered by our own driver',
      postal: 'Postal code (first 3 characters)', subtotal: 'Subtotal before tax (optional)',
      zone: 'Zone {z}', freeOver: 'Free delivery on {x} or more', ok: 'This order gets free delivery',
      need: 'Add {x} more for free delivery', choose: 'Under {x}, choose one:',
      optFee: 'Pay a {x} delivery fee', optWait: 'Free when our driver is next heading your way (no guaranteed date)',
      eta: 'Delivery time: ', noDrv: 'Our driver does not deliver to this area',
      webOn: 'Order at monesupply.ca: free Ontario shipping on ${a} or more, otherwise ${b}',
      webOther: 'Order at monesupply.ca: free shipping on ${a} or more, otherwise ${b}',
      unknown: 'This postal code is not on our list yet. Please ask the manager.',
      invalid: 'Enter the first 3 characters, e.g. L3P',
      basis: 'Based on the subtotal after discounts, before tax.',
      bulky: 'Furniture and large equipment: please confirm it fits our vehicle first.',
      staff: 'Staff: log a wait-for-route order', loading: 'Loading…',
      failed: 'Could not load the data. Check the connection and refresh.', stamp: 'Data updated {x}'
    },
    vi: {
      title: 'Tra cứu giao hàng', sub: 'Áp dụng cho đơn đặt tại cửa hàng, qua điện thoại và WeChat, do tài xế của tiệm giao',
      postal: 'Mã bưu chính (3 ký tự đầu)', subtotal: 'Tạm tính trước thuế (không bắt buộc)',
      zone: 'Khu vực {z}', freeOver: 'Miễn phí giao hàng cho đơn từ {x}', ok: 'Đơn này được giao hàng miễn phí',
      need: 'Mua thêm {x} để được giao miễn phí', choose: 'Đơn dưới {x} có thể chọn:',
      optFee: 'Trả phí giao hàng {x}', optWait: 'Miễn phí khi tài xế có chuyến tiện đường (không hẹn trước ngày giao)',
      eta: 'Thời gian giao: ', noDrv: 'Tài xế không giao đến khu vực này',
      webOn: 'Đặt hàng tại monesupply.ca: miễn phí vận chuyển trong Ontario cho đơn từ ${a}, dưới mức đó phí ${b}',
      webOther: 'Đặt hàng tại monesupply.ca: miễn phí vận chuyển cho đơn từ ${a}, dưới mức đó phí ${b}',
      unknown: 'Mã bưu chính này chưa có trong danh sách. Vui lòng hỏi quản lý.',
      invalid: 'Nhập 3 ký tự đầu, ví dụ L3P',
      basis: 'Tính theo tạm tính sau giảm giá, trước thuế.',
      bulky: 'Bàn ghế, thiết bị lớn: vui lòng xác nhận trước xem xe có chở được không.',
      staff: 'Nhân viên: ghi đơn chờ tiện đường', loading: 'Đang tải…',
      failed: 'Không tải được dữ liệu. Kiểm tra mạng rồi tải lại trang.', stamp: 'Dữ liệu cập nhật {x}'
    }
  };

  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };
  var lang = store.get('m1dz-lang');
  if (!T[lang]) lang = /^vi/i.test(navigator.language) ? 'vi' : /^zh/i.test(navigator.language) ? 'zh' : 'en';
  var data = null, loadError = false;
  var codeEl = document.getElementById('m1dz-code'), amtEl = document.getElementById('m1dz-amt');
  var out = document.getElementById('m1dz-out'), stampEl = document.getElementById('m1dz-stamp');

  function t(key, vars) {
    return T[lang][key].replace(/\{(\w)\}/g, function (_, k) { return vars[k]; });
  }
  function money(n) { return '$' + (n % 1 ? n.toFixed(2) : n.toLocaleString('en-CA')); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function parseCsv(text) {
    var rows = [], row = [], cell = '', q = false;
    text = text.replace(/^﻿/, '');
    for (var i = 0; i < text.length; i++) {
      var c = text[i];
      if (q) {
        if (c === '"' && text[i + 1] === '"') { cell += '"'; i++; }
        else if (c === '"') q = false;
        else cell += c;
      } else if (c === '"') q = true;
      else if (c === ',') { row.push(cell); cell = ''; }
      else if (c === '\n' || c === '\r') {
        if (c === '\r' && text[i + 1] === '\n') i++;
        row.push(cell); rows.push(row); row = []; cell = '';
      } else cell += c;
    }
    if (cell !== '' || row.length) { row.push(cell); rows.push(row); }
    var head = rows.shift().map(function (h) { return h.trim(); });
    return rows.filter(function (r) { return r.join('').trim(); }).map(function (r) {
      var o = {};
      head.forEach(function (h, j) { o[h] = (r[j] || '').trim(); });
      return o;
    });
  }
  function build(zonesCsv, fsaCsv) {
    var zones = {}, fsa = {};
    parseCsv(zonesCsv).forEach(function (z) {
      zones[z.Zone.toUpperCase()] = {
        free: parseFloat(z.FreeThreshold), fee: parseFloat(z.DeliveryFee),
        eta: { zh: z.ETA_ZH, en: z.ETA_EN, vi: z.ETA_VI }
      };
    });
    parseCsv(fsaCsv).forEach(function (f) {
      var code = f.Code.toUpperCase().replace(/\s/g, '');
      if (code && zones[f.Zone.toUpperCase()]) fsa[code] = [f.Area, f.Zone.toUpperCase()];
    });
    if (!Object.keys(zones).length || !Object.keys(fsa).length) throw new Error('empty sheet');
    return { zones: zones, fsa: fsa, at: Date.now() };
  }
  function getText(url) {
    return fetch(url, { cache: 'no-store' }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    });
  }

  function website(code) {
    var w = /^[KLMNP]/.test(code) ? WEB.on : WEB.other;
    return '<div class="m1dz-row">' + esc(t(w === WEB.on ? 'webOn' : 'webOther', { a: w[0], b: w[1] })) + '</div>';
  }
  function render() {
    var code = codeEl.value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 3);
    if (!data) {
      out.innerHTML = '<p class="m1dz-muted">' + esc(t(loadError ? 'failed' : 'loading')) + '</p>';
      return;
    }
    if (!code) { out.innerHTML = ''; return; }
    if (!/^[A-Z]\d[A-Z]$/.test(code)) {
      out.innerHTML = code.length < 3 ? '' : '<p class="m1dz-muted">' + esc(t('invalid')) + '</p>';
      return;
    }
    var hit = data.fsa[code] || data.fsa[code.slice(0, 2)];
    var html = '<div class="m1dz-card">';
    if (!hit) {
      if (/^[KLMNP]/.test(code)) html += '<div class="m1dz-area">' + code + '</div><div class="m1dz-big m1dz-need">' + esc(t('unknown')) + '</div>';
      else html += '<div class="m1dz-area">' + code + '</div><div class="m1dz-big m1dz-no">' + esc(t('noDrv')) + '</div>' + website(code);
      out.innerHTML = html + '</div>';
      return;
    }
    var z = data.zones[hit[1]];
    html += '<div class="m1dz-area">' + code + (hit[0] ? ' · ' + esc(hit[0]) : '');
    if (isNaN(z.free)) {
      out.innerHTML = html + '</div><div class="m1dz-big m1dz-no">' + esc(t('noDrv')) + '</div>' + website(code) + '</div>';
      return;
    }
    html += '<span class="m1dz-zone">' + esc(t('zone', { z: hit[1] })) + '</span></div>';
    var amt = parseFloat(amtEl.value.replace(/[^0-9.]/g, ''));
    var options = '<div class="m1dz-row">' + esc(t('choose', { x: money(z.free) })) + '<ol class="m1dz-opts"><li>' +
      esc(t('optFee', { x: money(z.fee) })) + '</li><li>' + esc(t('optWait')) + '</li></ol></div>';
    if (isNaN(amt)) {
      html += '<div class="m1dz-big">' + esc(t('freeOver', { x: money(z.free) })) + '</div>' + options;
    } else if (amt >= z.free) {
      html += '<div class="m1dz-big m1dz-ok">✓ ' + esc(t('ok')) + '</div>';
    } else {
      html += '<div class="m1dz-big m1dz-need">' + esc(t('need', { x: money(Math.round((z.free - amt) * 100) / 100) })) + '</div>' + options;
    }
    html += '<div class="m1dz-row m1dz-muted">' + esc(t('eta')) + esc(z.eta[lang] || z.eta.en || '') + '</div>';
    out.innerHTML = html + '</div>';
  }
  function paint() {
    root.querySelectorAll('[data-t]').forEach(function (el) { el.textContent = t(el.getAttribute('data-t')); });
    root.querySelectorAll('[data-lang]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-lang') === lang ? 'true' : 'false');
    });
    stampEl.textContent = data ? t('stamp', { x: new Date(data.at).toLocaleString(lang === 'zh' ? 'zh-CN' : lang === 'vi' ? 'vi-VN' : 'en-CA', { dateStyle: 'medium', timeStyle: 'short' }) }) : '';
    render();
  }

  root.querySelectorAll('[data-lang]').forEach(function (b) {
    b.addEventListener('click', function () { lang = b.getAttribute('data-lang'); store.set('m1dz-lang', lang); paint(); });
  });
  codeEl.addEventListener('input', render);
  amtEl.addEventListener('input', render);
  var pendingEl = document.getElementById('m1dz-pending');
  if (root.getAttribute('data-pending-url')) pendingEl.href = root.getAttribute('data-pending-url');
  else pendingEl.hidden = true;

  try { data = JSON.parse(store.get(CACHE_KEY)); } catch (e) { data = null; }
  if (data && !(data.zones && data.fsa)) data = null;
  paint();
  Promise.all([getText(root.getAttribute('data-zones-url')), getText(root.getAttribute('data-fsa-url'))])
    .then(function (r) { data = build(r[0], r[1]); store.set(CACHE_KEY, JSON.stringify(data)); })
    .catch(function () { loadError = true; })
    .then(paint);
})();
